module.exports = __webpack_public_path__ + "static/media/no-play-icon.4eb19f7c.png";